module.exports = __webpack_public_path__ + "img/buy-icon1.148997b.png";